import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

export default function useDayjs() {
  dayjs.extend(customParseFormat);
}
